module.exports = __webpack_public_path__ + "img/intelligence.5b176466.jpg";